import {loadTranslations, removeTranslations, saveTranslations} from "./storage";

const LANGUAGE_NAME = {
	'en': 'English',
	'es': 'Spanish',
	'fr': 'French',
};

export const initTranslation = (contactId, customerLanguage, agentLanguage) => {
	let translations = loadTranslations(contactId);
	if (translations?.hasOwnProperty('messages')) {
		return translations;
	}
	translations = {
		customerLanguage: customerLanguage,
		agentLanguage: agentLanguage,
		messages: {}
	};
	saveTranslations(contactId, translations);
	return translations;
}

export const deleteTranslation = (contactId) => {
	removeTranslations(contactId);
}

export const setTranslation = (contactId, messageId, text) => {
	let translations = loadTranslations(contactId);
	if (translations?.hasOwnProperty('messages')) {
		translations.messages[messageId] = text;
		saveTranslations(contactId, translations);
	}
}

export const isTranslationNeeded = (customerLanguage, agentLanguage) => {
	try {
		const c = customerLanguage?.split('-');
		const a = agentLanguage?.split('-');
		return c && a && (c[0] !== a[0]);
	} catch (ex) {}
	return false;
}

export const getTranslation = (contactId) => {
	let t = loadTranslations(contactId);
	if (t) {
		t.isTranslationNeeded = isTranslationNeeded(t?.customerLanguage, t?.agentLanguage);
	}
	return t;
}

export const getLanguageNameByCode = (languageCode) => {
	const langCodeLowercase = languageCode?.toLowerCase();
	const baseLangCode = langCodeLowercase?.split('-')[0];
	if (baseLangCode && LANGUAGE_NAME.hasOwnProperty(baseLangCode)) {
		return LANGUAGE_NAME[baseLangCode];
	}
	return languageCode?.toUpperCase();
}